import { missionStatuses } from '../../../../backend/extraTypes';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const missionHistoryEntityName = 'missionHistory';
export const missionHistorySchema = z.object({
    missionId: z.string().uuid(),
    status: z.enum(missionStatuses),
    internalStatusChange: z.boolean().optional(),
});
export const missionHistoryColumns = defineColumns({
    missionId: {
        type: 'id-required',
        index: true,
    },
    status: {
        type: 'string-required',
        index: true,
    },
});
